import { Form, Formik } from "formik";
import { Link as RouterLink } from "react-router-dom";

import { Box, Button, CircularProgress, Link, Typography } from "@mui/material";

import AuthLogos from "@components/AuthLogos";
import ForgotPassword from "@components/Forms/ForgotPassword";
import TextField from "@components/Forms/FormInputs/TextField";

import userService from "@services/user.service";

import { usePopupActions } from "@store/popupStore";

import contentCardStyles from "@theme/contentCardStyles";
import theme from "@theme/index";

import "@fontsource/league-spartan/700.css";

function LogIn() {
  const PopupActions = usePopupActions();

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 4,
        justifyContent: "center",
        overflowY: "auto",
        p: {
          sm: 4,
          xs: 2,
        },
      }}
    >
      <AuthLogos />
      <Box
        sx={{
          ...contentCardStyles,
          border: `1px solid ${theme.palette.grey[400]}`,
          display: "flex",
          flexDirection: "column",
          flexGrow: "unset",
          gap: 2,
          height: "fit-content",
          overflow: "visible",
          p: {
            sm: 5,
            xs: 4,
          },
          width: {
            sm: "560px",
            xs: "95%",
          },
        }}
      >
        <Typography
          align="center"
          sx={{
            mb: 2,
          }}
          variant="h3"
        >
          Log In
        </Typography>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await userService.signIn(values.email, values.password);
            } catch {
              setSubmitting(false);
            }
          }}
        >
          {({ dirty, isSubmitting, isValid }) => (
            <Box
              component={Form}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: "100%",
              }}
            >
              <TextField isFullWidth isRequired label="Work Email" name="email" type="email" />
              <Box
                sx={{
                  alignItems: "flex-end",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={() =>
                    PopupActions.openModal({
                      content: <ForgotPassword />,
                      title: "Reset Password",
                    })
                  }
                  size="small"
                >
                  Forgot password?
                </Button>
                <TextField isFullWidth isRequired label="Password" name="password" type="password" />
              </Box>
              <Button disabled={!isValid || !dirty || isSubmitting} size="large" type="submit" variant="contained">
                {isSubmitting ? <CircularProgress size={20} /> : <>Log In</>}
              </Button>
            </Box>
          )}
        </Formik>
        <Typography align="center" sx={{ fontWeight: 600, mt: 3 }} variant="h5">
          Need to create an account?{" "}
          <Link component={RouterLink} to="../signup">
            Sign up
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default LogIn;
